module.exports = __webpack_public_path__ + "img/waitlist-white.8a41169f.svg";